module.exports = () => ({
  name: {
    label: '姓名',
    type: 'input',
    value: '',
  },
});
